import { useTranslation } from '@mc/i18n'
import { Separator } from '@mc/design-system'
import { useStaticData } from '@mc/static-data-react'

const Preview = () => {
  const { chapter } = useStaticData()
  const { t } = useTranslation('@mc/next')

  if (!chapter?.chapterStructuredData?.articleBody) return <></>

  return (
    <section className='mc-py-10' id='transcript'>
      <Separator className='mc-my-0' />
      <h2 className='mc-text-h4 mc-mt-10'>{t('lesson.details.title')}</h2>
      <p className='mc-text--muted mc-text--pre-wrap mc-mt-4'>
        {chapter?.chapterStructuredData?.articleBody}
      </p>
    </section>
  )
}

export default Preview
